<template>
    <b-dropdown variant="outline-orange" :text="selected.text">
        <b-dropdown-item @click="emitSelected(item)" v-for="(item, index) in options" :key="index">
            {{ item.text }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
  export default {
    props: {
      options: Array,
      default: Object
    },

    data() {
      return {
        selected: {}
      }
    },

    methods: {
      emitSelected(item) {
        this.$emit('selected', item);
        this.setSelected(item);
      },
      setSelected(item) {
        this.selected = item;
      }
    },
    created() {
      this.selected = this.default;
    },

    watch: {
      default(item) {
        this.setSelected(item);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Common/Filter/DropDownFilter.vue